import { apiUserFetch } from '@/api';

import {
  CreateGammaTeamInvitationBody,
  MyGammaTeamInvitation,
  UpdateGammaTeamInvitationBody,
  UpdateGammaTeamMemberBody,
} from './types';

export const _createGammaTeamInvitation = (body: CreateGammaTeamInvitationBody) =>
  apiUserFetch('/invitations/gamma-team', { method: 'POST', body });

export const _updateGammaTeamInvitation = ({
  id,
  ...body
}: UpdateGammaTeamInvitationBody & { id: string }) =>
  apiUserFetch(`/invitations/${id}`, { method: 'PUT', body });

export const _cancelGammaTeamInvitation = (id: string) =>
  apiUserFetch(`/invitations/${id}/cancel`, { method: 'POST' });

export const _resendGammaTeamInvitation = (params: { email: string }) =>
  apiUserFetch(`/invitations/resend`, { method: 'POST', body: { email: params.email } });

export const _revokeGammaTeamInvitation = (params: { email: string }) =>
  apiUserFetch(`/invitations/revoke`, { method: 'POST', body: { email: params.email } });

export const _acceptGammaTeamInvitation = (id: string) =>
  apiUserFetch<MyGammaTeamInvitation>(`/invitations/${id}/accept`, { method: 'POST' });

export const _rejectGammaTeamInvitation = (id: string) =>
  apiUserFetch(`/invitations/${id}/reject`, { method: 'POST' });

export const _updateGammaTeamMember = ({
  userId,
  ...body
}: UpdateGammaTeamMemberBody & { userId: string }) =>
  apiUserFetch(`/admin/gamma-team/members/${userId}`, { method: 'PUT', body });

export const _deleteGammaTeamMember = (userId: string) =>
  apiUserFetch(`/admin/gamma-team/members/${userId}`, { method: 'DELETE' });
